<template>
  <div>
    <!-- 标题部分 -->
    <div class="m-news-g1">
      <a href="javascript:;">
        <h3>最新品牌全案案例</h3>
        <p>品牌策略+创意设计+营销推广一步到位</p>
        <i class="icon"></i>
      </a>
    </div>

    <!-- 案例列表 -->
    <div class="m-list-g1">
      <div class="wp" v-loading="loading" element-loading-text="加载中...">
        <ul class="ul-imgtxt-g1">
          <li v-for="(item, index) in brandCases" :key="item.id || index">
            <div class="con">
              <router-link :to="item.id ? `/brand-case-detail/${item.id}` : '/brand-case'">
                <div class="pic">
                  <img v-if="item.cover || item.image" :src="item.cover || item.image" :alt="item.title" class="case-cover-img" />
                  <div v-else class="placeholder-image">{{ item.title }}</div>
                </div>
                <div class="txt">
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.description }}</p>
                </div>
              </router-link>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { getBrandCasesList } from '@/api/brandCases'

export default {
  name: 'BrandCases',
  data() {
    return {
      brandCases: [],
      loading: false
    }
  },
  created() {
    this.loadBrandCases()
  },
  methods: {
    // 从后端接口加载品牌全案案例列表（/studies/brandCase/list）
    loadBrandCases() {
      this.loading = true
      getBrandCasesList({ pageNum: 1, pageSize: 20, status: '1' })
        .then(response => {
          if (response.code === 200) {
            const list = response.rows || (Array.isArray(response.data) ? response.data : (response.data && response.data.rows) || [])
            this.brandCases = list.map(item => ({
              id: item.id,
              title: item.title || '',
              description: item.description || '',
              link: item.link || '#',
              cover: item.cover || null,
              image: item.image || null
            }))
            if (this.brandCases.length === 0) {
              this.brandCases = this.getDefaultBrandCases()
            }
          } else {
            this.$message.error(response.msg || '获取品牌全案案例失败')
            this.brandCases = this.getDefaultBrandCases()
          }
        })
        .catch(error => {
          console.error('获取品牌全案案例失败:', error)
          this.$message.error('获取品牌全案案例失败，请稍后重试')
          this.brandCases = this.getDefaultBrandCases()
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 接口失败时的默认数据（降级方案）
    getDefaultBrandCases() {
      return [
        { id: 1, title: '热泰能源科技冷水机品牌全案策划|冷水机品牌策划品牌形象设计', description: '合作内容：品牌定位，品牌规划，品牌文化，品牌卖点，品牌形象设计，网站搭建，品牌宣传册设计，品牌logo、VI设计热泰能源公司简介：上海热', link: 'brand/brand/show-66-1109-1.html', cover: null, image: null },
        { id: 2, title: '食品品牌策划_休闲食品营销策划-喔喔奶糖品牌升级', description: '全案整合营销给喔喔集团带来的价值 喔喔全新蜕变强势回归，2017招商金额突破1 5亿', link: 'brand/brand/show-66-485-1.html', cover: null, image: null },
        { id: 3, title: '教育品牌全案策划-北京金峰练字品牌形象设计升级策划上海', description: '金峰练字产品多样化、系统专业，用管家式专业指导，从不同层面照顾到学员现阶段的练字水平，让全龄段学员均可潜心学习，品牌形象要具备包容性', link: 'brand/brand/show-66-907-1.html', cover: null, image: null },
        { id: 4, title: '餐饮品牌品牌升级：掘金连锁餐饮行业策划，品牌设计战略伊秀日本料理', description: '前言：近年来餐饮行业里的竞争变得越来越激烈，这也对餐饮品牌也提出了越来越高的要求，餐饮品牌如何充分发掘自身的特色，并基于自身的特色', link: 'brand/brand/show-66-906-1.html', cover: null, image: null },
        { id: 5, title: '连锁餐饮行业品牌营销策划-连锁餐饮企业品牌设计-熊觅花样好食社区店', description: '前言随着餐饮行业的高度发展，行业竞争早已白热化，为了近距离争夺有限的存量顾客，餐饮进社区已经成为了不可逆转的趋势，在这样的行业大势', link: 'brand/brand/show-66-905-1.html', cover: null, image: null },
        { id: 6, title: '嘻嘻未来绘教育品牌策划设计，打造体验式儿童场景教育新标杆', description: '嘻嘻未来绘品牌策划设计，打造体验式儿童场景教育新标杆万事开头难，一个新企业在进入市场之初，都要经历九九八十一难，才', link: 'brand/brand/show-66-902-1.html', cover: null, image: null },
        { id: 7, title: '嫥妍美容仪器品牌定位包装全案策划 美容棒化妆品行业品牌全案设计', description: '年轻、青春不是表面的简单护理就能完成的，真正的年轻、真正的青春是由内而发的。从内开始，定频微波、震荡刺激，激励皮肤细胞，产生更多胶原蛋白，让肌肤焕发新生。焕活细胞，焕发青春，家用便捷美容棒', link: 'brand/brand/show-66-899-1.html', cover: null, image: null },
        { id: 8, title: '高端男装品牌全案策划|梵一集polo衫 T恤衫男装战略定位品牌落地', description: '客户初心：做一个只卖polo衫和T恤衫的高品质男装 品牌服务内容：品牌全案策划、品牌定位，品牌命名，超级口号，卖点体系，品牌故事', link: 'brand/brand/show-66-895-1.html', cover: null, image: null },
        { id: 9, title: '燕集鲜炖燕窝品牌全案策划：从调研到落地，掌握品牌发展之路', description: '价格贵与不知道怎么吃是痛点；品牌运营缺失，品牌路线是痛点，价格是弥补；鲜炖燕窝送礼愿意尝试，自己食用；尝试的鲜炖燕窝功效与食用频次不清楚；想简单食用，省的麻烦', link: 'brand/brand/show-66-893-1.html', cover: null, image: null },
        { id: 10, title: '生鲜市场红海竞争中的品牌增长之道|四季优鲜全生鲜超市品牌全案策划', description: '离消费者越近，离增长越近；有曝光量，也要有点击率；为四季优鲜全打造一个活泼可爱的品牌形象-优鲜妹，象征着新鲜、欢快之形象，并将IP形象特性赋能到门店中，实现让人一眼识别、一眼记住、吸引顾客的品牌之道', link: 'brand/brand/show-66-890-1.html', cover: null, image: null }
      ]
    }
  }
}
</script>

<style scoped>
.m-news-g1 {
  padding: 52px 0 20px;
  text-align: center;
  background: #fff;
}

.m-news-g1 a {
  display: inline-block;
  text-decoration: none;
  position: relative;
}

.m-news-g1 h3 {
  font-size: 36px;
  color: #242526;
  line-height: 1.4;
  font-weight: 400;
  margin-bottom: 6px;
}

.m-news-g1 p {
  font-size: 18px;
  color: #666;
  line-height: 1.4;
}

.m-news-g1 .icon {
  display: inline-block;
  width: 30px;
  height: 3px;
  background: #EA4043;
  margin-top: 10px;
}

.m-list-g1 {
  padding: 20px 0 60px;
  background: #fff;
}

.m-list-g1 .wp {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.ul-imgtxt-g1 {
  overflow: hidden;
  list-style: none;
  padding: 0;
  margin: 0 -15px;
}

.ul-imgtxt-g1 li {
  float: left;
  width: 50%;
  padding: 0 15px;
  margin-bottom: 30px;
  box-sizing: border-box;
}

.ul-imgtxt-g1 .con {
  display: block;
  position: relative;
  overflow: hidden;
}

.ul-imgtxt-g1 a {
  display: block;
  text-decoration: none;
  color: inherit;
  position: relative;
  overflow: hidden;
}

.ul-imgtxt-g1 .pic {
  width: 100%;
  padding-top: 58.8%;
  position: relative;
  overflow: hidden;
  background: #f5f5f5;
}

.ul-imgtxt-g1 .pic .case-cover-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.placeholder-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
  text-align: center;
  padding: 20px;
  font-weight: 300;
  letter-spacing: 0.5px;
  line-height: 1.4;
  transition: transform 0.5s ease;
  transform: scale(1);
}

.ul-imgtxt-g1 .con:hover .placeholder-image {
  transform: scale(1.1);
}

.ul-imgtxt-g1 .txt {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  padding: 30px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.4) 50%, transparent 100%);
  z-index: 2;
}

.ul-imgtxt-g1 .txt h3 {
  font-size: 20px;
  color: #fff;
  line-height: 1.6;
  margin-bottom: 10px;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ul-imgtxt-g1 .txt p {
  font-size: 14px;
  color: #fff;
  line-height: 1.8;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  opacity: 0.9;
}

@media (max-width: 768px) {
  .m-news-g1 {
    padding: 40px 0 15px;
  }

  .m-news-g1 h3 {
    font-size: 28px;
  }

  .m-news-g1 p {
    font-size: 16px;
  }

  .m-list-g1 {
    padding: 15px 0 40px;
  }

  .ul-imgtxt-g1 {
    margin: 0 -10px;
  }

  .ul-imgtxt-g1 li {
    width: 50%;
    padding: 0 10px;
    margin-bottom: 20px;
  }

  .ul-imgtxt-g1 .txt {
    padding: 20px;
  }

  .ul-imgtxt-g1 .txt h3 {
    font-size: 16px;
  }

  .ul-imgtxt-g1 .txt p {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .ul-imgtxt-g1 li {
    width: 100%;
  }
}
</style>
